import { render, staticRenderFns } from "./Text_NoResults_Small.vue?vue&type=template&id=0691b2bb&"
import script from "./Text_NoResults_Small.vue?vue&type=script&lang=js&"
export * from "./Text_NoResults_Small.vue?vue&type=script&lang=js&"
import style0 from "./Text_NoResults_Small.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports